import React from "react"
import { Box, IconButton, styled } from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { useResponsive } from "src/utils/useResponsive"

const ToggleMenuSize = styled("div")(({ theme }) => ({
  position: "fixed",
  bottom: "56px",
  transition: theme.transitions.create("left", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  transform: "translateX(-50%) translateY(50%)",
  zIndex: 100,
  variants: [
    {
      props: (props: any) => props.open,
      style: {
        left: "250px"
      }
    },
    {
      props: (props: any) => !props.open,
      style: {
        left: `calc(${theme.spacing(4)} + 20px)`
      }
    }
  ]
}))

interface Props {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const ToggleMenu = ({ open, setOpen }: Props) => {
  const { isMobile } = useResponsive()

  // Don't render anything on mobile since we now have the App Bar
  if (isMobile) {
    return null
  }

  return (
    <Box sx={{ alignItems: "center", display: "flex" }}>
      <ToggleMenuSize open={open}>
        <IconButton
          onClick={() => setOpen((prev) => !prev)}
          sx={{
            boxShadow: "1px 1px 6px #00000029",
            backgroundColor: "white",
            width: "24px",
            height: "24px"
          }}
        >
          {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </ToggleMenuSize>
    </Box>
  )
}
